import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BaseLinkComponent } from '../base/base-button.component';

@Component({
  selector: 'immo-link',
  imports: [
    MatRippleModule,
    MatIconModule,
    RouterLink
  ],
  templateUrl: './link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './link.component.css',
})
export class LinkComponent extends BaseLinkComponent { }
